import { inject, Injectable } from "@angular/core";
import { AuthToken, RefreshToken } from "@pcp/core/interfaces";
import { StringUtil } from "@pcp/core/util";
import { TOKEN_STORAGE_ADAPTER } from "../injection-tokens";

/**
 * Get and update AccessToken/RefreshToken.
 * Uses either localStorage or sessionStorage.
 */
@Injectable({
    providedIn: 'root',
})
export class PersistentTokenStorageService {

    private readonly TOKEN_STORAGE_KEY = 'token';
    private readonly REFRESH_TOKEN_STORAGE_KEY = 'refreshToken';
    private readonly LIVE_LESSON_TOKEN_STORAGE_KEY = 'pcp-live-token';

    private readonly storage: Storage = inject(TOKEN_STORAGE_ADAPTER);

    getAccessToken = () => this.getStringValue(this.TOKEN_STORAGE_KEY);
    getRefreshToken = () => this.getStringValue(this.REFRESH_TOKEN_STORAGE_KEY);
    getLiveLessonToken = () => this.getStringValue(this.LIVE_LESSON_TOKEN_STORAGE_KEY);

    setAccessToken = (value: AuthToken) => this.setStringValue(this.TOKEN_STORAGE_KEY, value);
    setRefreshToken = (value: RefreshToken) => this.setStringValue(this.REFRESH_TOKEN_STORAGE_KEY, value);
    setLiveLessonToken = (value: RefreshToken) => this.setStringValue(this.LIVE_LESSON_TOKEN_STORAGE_KEY, value);

    clear() {
        this.storage.removeItem(this.TOKEN_STORAGE_KEY);
        this.storage.removeItem(this.REFRESH_TOKEN_STORAGE_KEY);
        this.storage.removeItem(this.LIVE_LESSON_TOKEN_STORAGE_KEY);
    }

    private setStringValue(key: string, value: string) {
        this.storage.setItem(key, value);
    }

    private getStringValue(key: string) {
        const token = this.storage.getItem(key);

        if (token && typeof token === 'string' && token !== StringUtil.Empty) {
            return token;
        }

        return undefined;
    }

}
